import { environment } from './../../../../environments/environment';
import { Injectable } from '@angular/core';
import { from, map, switchMap, tap, throwError } from 'rxjs';
import { User } from 'app/core/api/types';
import { ApiService } from 'app/core/api/api.service';
import { AuthStrategy } from './auth.strategy';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { Action } from '@ngrx/store';
import { ActionCodeSettings } from 'firebase/auth';


@Injectable()
export class FirebaseAuthStrategy extends AuthStrategy {
    constructor(private api: ApiService) { super(); }

    // override initialize() {
    //     return from(FirebaseAuthentication.getCurrentUser()).pipe(
    //         switchMap(res => Promise.resolve({ loggedIn: !!res.user }))
    //     );
    // }


    override initialize() {
        return from(FirebaseAuthentication.getCurrentUser()).pipe(
            map(res => ({ loggedIn: !!res.user })),
            tap(() => {
                // hier: dispatch(authActions.initialized())
            })
        );
    }

    override login(email: string, password: string) {
        return from(FirebaseAuthentication.signInWithEmailAndPassword({ email, password })).pipe(
            switchMap(async res => {
                if (!res.user) throw new Error('No user returned');
                const tokenRes = await FirebaseAuthentication.getIdToken();
                return { accessToken: tokenRes.token, refreshToken: '' };
            })
        );
    }

    override getCurrentUser() {
        return this.api.getCurrentUser();
    }

    override logout() {
        return from(FirebaseAuthentication.signOut()).pipe(
            switchMap(() => Promise.resolve())
        );
    }

    override resetPassword(email: string) {
        const actionCodeSettings = this.getActionCodeSettings();
        return from(FirebaseAuthentication.sendPasswordResetEmail({ email, actionCodeSettings }));
    }

    override deleteUser(userId: string) {
        return from(FirebaseAuthentication.getCurrentUser()).pipe(
            switchMap(res => {
                if (!res.user || res.user.uid !== userId) {
                    return throwError(() => new Error('No user signed in or mismatched userId'));
                }
                return from(FirebaseAuthentication.deleteUser()).pipe(
                    switchMap(() => this.api.deleteUser(userId))
                );
            })
        );
    }



    override saveUser(user: User) {
        return this.api.saveUser(user);
    }

    override saveProfilePicture(file: File) {
        return this.api.updateProfilePictureUser(file);
    }

    getActionCodeSettings(): ActionCodeSettings {

        switch (environment.environmentName) {
            case 'prod': {
                return {
                    url: 'https://ammsas-app.com/login',
                    handleCodeInApp: true,
                    iOS: {
                        bundleId: 'com.noricainformatics.ammsas'
                    },
                    android: {
                        packageName: 'com.noricainformatics.ammsas',
                        installApp: true,
                        minimumVersion: '12'
                    }
                }
            }
            case 'stage': {
                return {
                    url: 'https://stage.ammsas-app.com/login',
                    handleCodeInApp: true,
                    iOS: {
                        bundleId: 'com.noricainformatics.ammsas.stage'
                    },
                    android: {
                        packageName: 'com.noricainformatics.ammsas.stage',
                        installApp: true,
                        minimumVersion: '12'
                    }
                }
            }
            case 'dev': {
                return {
                    url: 'https://dev.ammsas-app.com/login',
                    handleCodeInApp: true,
                    iOS: {
                        bundleId: 'com.noricainformatics.ammsas.dev'
                    },
                    android: {
                        packageName: 'com.noricainformatics.ammsas.dev',
                        installApp: true,
                        minimumVersion: '12'
                    }
                }
            }
            default: {
                return {
                    url: 'https://dev.ammsas-app.com/login',
                    handleCodeInApp: true,
                    iOS: {
                        bundleId: 'com.noricainformatics.ammsas.dev'
                    },
                    android: {
                        packageName: 'com.noricainformatics.ammsas.dev',
                        installApp: true,
                        minimumVersion: '12'
                    }
                }
            }
        }
    }
}
